var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 10.9498L14.8 2.9998C14.2 2.3998 13.3 2.3998 12.7 2.9998C12.4 3.2998 12.25 3.6748 12.25 4.0498V10.1998L5.05 2.9998C4.45 2.3998 3.55 2.3998 2.95 2.9998C2.65 3.2998 2.5 3.6748 2.5 4.0498V19.9498C2.5 20.7748 3.175 21.4498 4 21.4498C4.375 21.4498 4.75 21.2998 5.05 20.9998L12.25 13.7998V19.9498C12.25 20.7748 12.925 21.4498 13.75 21.4498C14.125 21.4498 14.5 21.2998 14.8 20.9998L22.75 13.0498C23.35 12.4498 23.35 11.5498 22.75 10.9498Z",
    fill: "#495260"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkip);
export default __webpack_public_path__ + "static/media/skip.215a3e55aa0d08cf0a578636830dcd41.svg";
export { ForwardRef as ReactComponent };